<template>
  <router-view />
  <Head>
    <template v-slot:title="{ content }">{{ content }}</template>
  </Head>
</template>

<script>
import { mapMutations } from 'vuex';

const EMBED_MARK = 'data-tki-embed';
const EMBED_HEAD_ATTR = 'data-tki-embed-head';
const EMBED_BODY_ATTR = 'data-tki-embed-body';

export default {
  created() {
    document.addEventListener('keydown', e => {
        let key = e.key;
        if (key && 'Escape' === key) {
            this.$store.commit('forceCloseModal')
        }
    }, false);

    if(document.cookie.indexOf('modal=true') === -1) {
      setTimeout(function() {
        this.$store.commit('toggleModal', 'newsletter');
      }.bind(this),3000)
    }
    // 將"是否同意限制級"回歸預設值
    if(this.setR18Agree) {
      this.setR18Agree(false);
    }
  },
  mounted() {
    // DOM 就緒後再注入埋碼（created 時偶發過早）
    this.injectEmbedFromSettings();
  },
  watch: {
    '$route': 'handleRouteChange'
  },
  methods: {
    ...mapMutations('activity', ['setR18Agree']),
    handleRouteChange(newRoute) {
      // 手機、平板開啟社群網站，自動導向外部瀏覽器
      const isMobileOrTablet = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    
      if (isMobileOrTablet) {
        this.$router.push({ path: newRoute.fullPath, query: { ...this.$route.query, openExternalBrowser: 1 } });
      } 
    },
    clearPreviousEmbed() {
      document.querySelectorAll(`[${EMBED_MARK}]`).forEach((el) => el.remove());
      document.querySelectorAll(`[${EMBED_HEAD_ATTR}], [${EMBED_BODY_ATTR}]`).forEach((el) => el.remove());
    },
    createNodesFromHtml(html) {
      if (!html || !String(html).trim()) {
        return [];
      }
      const template = document.createElement('template');
      template.innerHTML = String(html).trim();
      return Array.from(template.content.childNodes).filter(
        (n) => n.nodeType === Node.ELEMENT_NODE || n.nodeType === Node.COMMENT_NODE
      );
    },
    materializeNode(node, markAttr) {
      if (node.nodeType === Node.COMMENT_NODE) {
        return node.cloneNode(true);
      }
      if (node.tagName === 'SCRIPT') {
        const script = document.createElement('script');
        Array.from(node.attributes || []).forEach((attr) => {
          script.setAttribute(attr.name, attr.value);
        });
        script.text = node.textContent || '';
        script.setAttribute(EMBED_MARK, '1');
        script.setAttribute(markAttr, '1');
        return script;
      }
      const clone = node.cloneNode(true);
      if (clone.setAttribute) {
        clone.setAttribute(EMBED_MARK, '1');
        clone.setAttribute(markAttr, '1');
      }
      return clone;
    },
    injectIntoHead(html) {
      const nodes = this.createNodesFromHtml(html);
      // 由後往前插，維持原始順序在 head 最上方
      for (let i = nodes.length - 1; i >= 0; i -= 1) {
        const el = this.materializeNode(nodes[i], EMBED_HEAD_ATTR);
        document.head.insertBefore(el, document.head.firstChild);
      }
    },
    injectIntoBodyBottom(html) {
      const nodes = this.createNodesFromHtml(html);
      nodes.forEach((node) => {
        document.body.appendChild(this.materializeNode(node, EMBED_BODY_ATTR));
      });
    },
    async injectEmbedFromSettings() {
      try {
        const apiUrl = `${process.env.VUE_APP_PATH}/server/settings`;
        let data = null;
        if (this.axios) {
          const res = await this.axios.get(apiUrl);
          data = res.data;
        } else {
          const res = await fetch(apiUrl);
          data = await res.json();
        }
        if (!data || data.status_code !== 'SYSTEM_1000') {
          console.warn('[TKI embed] settings API 回應異常', data);
          return;
        }
        const payload = data.data || {};
        const headHtml = payload.embed_head_html || '';
        const bodyHtml = payload.embed_body_html || '';

        this.clearPreviousEmbed();
        this.injectIntoHead(headHtml);
        this.injectIntoBodyBottom(bodyHtml);

        if (headHtml || bodyHtml) {
          console.info('[TKI embed] 埋碼已注入', {
            head: Boolean(headHtml),
            body: Boolean(bodyHtml),
            headMeta: document.querySelector('meta[name="tki-embed-test"]') ? 'found' : 'missing',
            bodyIframe: document.querySelector('iframe[title="tki-embed-test"]') ? 'found' : 'missing',
          });
        }
      } catch (e) {
        console.warn('[TKI embed] injectEmbedFromSettings failed', e);
      }
    },
  }
};
</script>
<style lang="scss">
@import "./assets/all.scss";
</style>
